import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../api/axios';
import { useChampionTheme } from '../../components/ChampionElements';

export default function TranscriptView() {
  const { webinarId } = useParams();
  const [transcripts, setTranscripts] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const t = useChampionTheme();

  useEffect(() => {
    const fetchTranscripts = async () => {
      try {
        const res = await api.get(`/api/member/webinars/${webinarId}/transcripts`);
        setTranscripts(res.data);
        if (res.data.length > 0) setSelected(res.data[0]);
      } catch (err) { console.error('Gagal memuat transkrip:', err); }
      finally { setLoading(false); }
    };
    fetchTranscripts();
  }, [webinarId]);

  if (loading) return <div className="text-center py-5"><div className="spinner-border" style={{ color: t.gold }} role="status" /><p className="mt-3" style={{ color: t.gold }}>Memuat transkrip...</p></div>;

  if (transcripts.length === 0) return (
    <div className="text-center py-5">
      <i className="bi bi-journal-text" style={{ fontSize: '3rem', color: t.textMuted }}></i>
      <p className="mt-3" style={{ color: t.textMuted }}>Belum ada transkrip tersedia.</p>
    </div>
  );

  return (
    <div style={{ animation: 'slide-in-up 0.5s ease' }}>
      <div className="d-flex align-items-center gap-2 mb-4">
        <i className="bi bi-journal-text" style={{ color: t.gold, fontSize: '1.5rem' }}></i>
        <h5 style={{ color: t.gold, fontWeight: 700, margin: 0 }}>Transkrip</h5>
      </div>
      {transcripts.length > 1 && (
        <div className="mb-3">
          <select className="form-select" value={selected?.id || ''}
            onChange={e => setSelected(transcripts.find(tr => tr.id == e.target.value))}
            style={{ backgroundColor: t.cardBg, border: `1px solid ${t.gold}33`, color: t.text, borderRadius: '10px', padding: '10px 14px', fontWeight: 500 }}>
            {transcripts.map(tr => (
              <option key={tr.id} value={tr.id} style={{ backgroundColor: t.bg, color: t.text }}>
                {tr.episode ? `Episode: ${tr.episode.title}` : 'Transkrip Umum'}
              </option>
            ))}
          </select>
        </div>
      )}
      {selected && (
        <div className="card" style={{ backgroundColor: t.cardBg, border: `1px solid ${t.border}`, borderRadius: '14px' }}>
          <div className="card-body" style={{ whiteSpace: 'pre-wrap', lineHeight: '1.9', color: t.text, fontSize: '0.95rem' }}>
            {selected.content}
          </div>
        </div>
      )}
    </div>
  );
}
